import { Checkbox, FormControl, FormControlLabel, Typography } from '@mui/material';

interface FormikCheckBoxProps {
    heading: string;
    label?: string;
    showValue?: boolean;
    name: string;
    value: any;
    handleChange: (event: any) => void;
    dataTestId?: string;
    disabled?: boolean;
}

const FormLabel: React.FC<{
    heading: string;
    label?: string;
    showValue?: boolean;
}> = ({ heading, label, showValue }) => {
    return (
        <>
            <Typography color="#1D1D1B" fontSize="14px" lineHeight="21px" fontWeight="700">
                {heading}
            </Typography>
            {showValue && (
                <Typography color="#8E8E8D" fontSize="16px" fontWeight="400" marginTop="5.5px">
                    {label}
                </Typography>
            )}
        </>
    );
};

export const ControlledCheckBox: React.FC<FormikCheckBoxProps> = ({
    heading,
    value,
    showValue = true,
    name,
    label,
    handleChange,
    dataTestId = `${name}-checkbox`,
    disabled,
}) => {
    return (
        <FormControl component="fieldset">
            <FormControlLabel
                control={
                    <Checkbox
                        inputProps={{ 'data-testid': dataTestId }}
                        checked={value}
                        onChange={handleChange}
                        name={name}
                        disabled={disabled}
                    />
                }
                label={<FormLabel heading={heading} label={label} showValue={showValue} />}
            />
        </FormControl>
    );
};
